<template>
<div class="member-overview">
    <v-row>
        <v-col cols="12" sm="6" md="3" v-if="$page.props.p['members.payments.read']">
            <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/payments'" >
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.payments || "Payments" }}</v-card-title>
                    <v-card-subtitle>/</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <v-avatar size="50" tile>
                               {{ organization.settings.currency }}
                            </v-avatar>
                        </v-col>
                        <v-col cols="8">
                            <h3 class="value"> {{ Number.parseFloat(member.total_payments).toFixed(2) }}</h3>
                        </v-col>
                    </v-row>                     
                </v-card>
            </inertia-link>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="$page.props.p['members.payments.read']">
            <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/payments'" >
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.debt || "Total Debt" }}</v-card-title>
                    <v-card-subtitle>/</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <v-avatar size="50" tile>
                               {{ organization.settings.currency }}
                            </v-avatar>
                        </v-col>
                        <v-col cols="8">
                            <h3 class="value"> {{ Number.parseFloat(member.total_debt).toFixed(2) }}</h3>
                        </v-col>
                    </v-row>                     
                </v-card>
            </inertia-link>
        </v-col>
        <v-col cols="12" sm="6" md="3">
            <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/visits'">
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.visits || "Visits" }}</v-card-title>
                      <v-card-subtitle>{{ $page.props.lang.total_visits || "Total visits" }}</v-card-subtitle>
                      <v-row>
                          <v-col  cols="4">
                              <v-avatar size="50" tile>
                                  <v-icon>mdi-check-all</v-icon>
                              </v-avatar>
                          </v-col>
                          <v-col cols="8">
                              <h3 class="value">{{ member.number_of_visits }}</h3>
                          </v-col>
                      </v-row>                   
                </v-card>
            </inertia-link>
        </v-col>
         <v-col cols="12" sm="6" md="3">
            <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/notes'" v-show="$page.props.p['members.manage']">
                  <v-card elevation="1">
                      <v-card-title>{{ $page.props.lang.notes || "Notes" }}</v-card-title>
                      <v-card-subtitle>{{ $page.props.lang.total_notes || "Total number of notes" }}</v-card-subtitle>
                      <v-row>
                          <v-col  cols="4">
                              <v-avatar size="50" tile>
                                  <v-icon>mdi-text</v-icon>
                              </v-avatar>
                          </v-col>
                          <v-col cols="8">
                              <h2 class="value">{{ member.note_cnt }}</h2>
                          </v-col>
                      </v-row>
                  </v-card>
            </inertia-link>
          </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="6" md="12">
           <v-card elevation="1">
               <v-card-title>
                <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/subscriptions'">
                    {{ $page.props.lang.active_subscriptions || "Active memberships" }}
                </inertia-link>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="activeSubscriptions != 0">
                    <v-row>
                        <v-col cols="12" md="6" sm="12" v-for="subscription in activeSubscriptions" :key="subscription.id">
                             <inertia-link :href="'/backoffice/members/details/'+$page.props.member.id+'/subscription/'+ subscription.id">
                            <v-card elevation="0" style="background:#cacaca">
                                <v-card-title>{{ subscription.name }}
                                    <div v-if="!($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)"> 
                                        <v-chip v-if="subscription.contains_unpaid" style="position:absolute; top:12px; right:6px;" class="ma-2" color="red" text-color="white" small>
                                        <v-icon small left>mdi-alert-circle-outline</v-icon>
                                        {{ $page.props.lang.unpaid || "Unpaid"}}
                                        </v-chip>
                                        <v-chip v-else class="ma-2" color="#4ede77" text-color="white" style="position:absolute; top:12px; right:6px;" small> 
                                        <v-icon small left>mdi-currency-usd</v-icon>
                                        {{ $page.props.lang.paid || "Paid"}} 
                                        </v-chip>
                                    </div>
                                    <div v-else>
                                        <v-icon v-if="subscription.contains_unpaid" color="red" class="ml-1" small>mdi-alert-circle-outline</v-icon>
                                    </div>
                                </v-card-title>
                               
                                <v-card-text>
                                    <ul style="list-style:none;margin:0; padding:0">
                                        <li>{{ $page.props.lang.startDate || "Start Date" }}: {{ subscription.start_date | formatDate }}</li>
                                        <li v-if="subscription.end_date !== 'Until cancelation'">{{ $page.props.lang.endDate || "End Date" }}: {{ subscription.end_date }}</li>
                                        <li v-else>{{ $page.props.lang.endDate || "End Date" }}: {{ $page.props.lang.until_cancelation || "Until cancelation" }}</li>
                                        <li>{{ $page.props.lang.current_period || "Current period" }}: {{ subscription.current_period }}</li>
                                        <li>{{subscription.remaining }}</li>
                                    </ul>
                                   
                                </v-card-text>
                            </v-card>
                             </inertia-link>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-else class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_active_memberships || "No active memberships..."}}</v-card-text>
            </v-card>
        </v-col>
        </v-row>
        <v-row class="mb-1">
            <v-col cols="12" sm="6" md="6">
                  <v-card elevation="1">
                      <v-card-title>{{ $page.props.lang.appointments || "Appointments" }}</v-card-title>
                      <v-row>
                      <v-col cols="12">
                        <div class="totals">
                          <div class="total" @click="openAppointmentsModal(1)">
                              <div class="data">
                                  <h4 class="amount">
                                      {{ member.appointments != null ? member.appointments.finished : 0 }}
                                  </h4>
                                  <div class="info-title">{{ $page.props.lang.attended || "Attended" }}</div>
                              </div>
                          </div>
                           <div class="total" style="cursor:unset">
                              <div class="data">
                                  <h4 class="amount">
                                      {{ member.appointments != null ? member.appointments.future : 0 }}
                                  </h4>
                                  <div class="info-title">{{ $page.props.lang.future || "Future"}}</div>
                              </div>
                          </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                            <div class="totals">
                            <div class="total" @click="openAppointmentsModal(0)">
                                <div class="data">
                                    <h4 class="amount">
                                        {{ member.appointments != null ? member.appointments.missing : 0 }}
                                    </h4>
                                    <div class="info-title">{{ $page.props.lang.missing || "Missing" }}</div>
                                </div>
                            </div>
                            <div class="total" @click="openAppointmentsModal(-1)">
                                <div class="data">
                                    <h4 class="amount">
                                        {{ member.appointments != null ? member.appointments.canceled : 0 }}
                                    </h4>
                                    <div class="info-title">{{ $page.props.lang.canceled || "Canceled" }}</div>
                                </div>
                            </div>
                            </div>
                        </v-col>
                      </v-row>
                  </v-card>
            </v-col>
        </v-row>

        <appointments-dialog v-if="viewAppointmentsModal" @on-close="viewAppointmentsModal = false" :open="viewAppointmentsModal" :member="member" :status="appointmentStatus"></appointments-dialog>
   </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmModal from '@/js/Components/ConfirmModal'
import AppointmentsDialog from './Components/AppointmentsDialog.vue'

export default {
    metaInfo() {
        return{
            title: this.$page.props.member.full_name + ' - '+ (this.$page.props.lang.title || "Member Overview")
        }
    },
    name:"MemberOverview",
    components: {
        ConfirmModal,
        AppointmentsDialog
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        user:Object,
        member: Object,
        activeSubscriptions: Array,
        errors: Object,
        lang: Object,
        sms_credit: Number,
        use_mobile_app: Number,
        organization: Object
    },
    data(){
      return {
        appointmentStatus: 1,
        viewAppointmentsModal: false
      }
    },
    methods: {
        openAppointmentsModal(status) {
            this.appointmentStatus = status;
            this.viewAppointmentsModal = true;
        },

        ceca(){
            alert('sadsa');
        }
    }
}

</script>
